import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

// Định dạng ngày giờ dùng chung cho toàn bộ màn History.
export const HISTORY_DATE_FORMAT = "DD/MM/YYYY HH:mm:ss";

// Chuỗi dạng ngày-trước (DD/MM/YYYY...) phải parse strict: new Date() hiểu
// "09/10/2026" là 10 tháng 9 (MM/DD) -> sai ngày.
const DAY_FIRST_RE = /^\d{1,2}[/-]\d{1,2}[/-]\d{4}/;
const DAY_FIRST_FORMATS = [
  "DD/MM/YYYY HH:mm:ss",
  "DD/MM/YYYY HH:mm",
  "DD/MM/YYYY",
  "D/M/YYYY H:mm:ss",
  "D/M/YYYY H:mm",
  "D/M/YYYY",
  "DD-MM-YYYY HH:mm:ss",
  "DD-MM-YYYY HH:mm",
  "DD-MM-YYYY",
];

const toMs = (n) => (n < 1e12 ? n * 1000 : n); // timestamp giây -> mili giây

/**
 * Nhận Date / timestamp (giây hoặc ms, số hoặc chuỗi) / chuỗi ISO / chuỗi
 * DD/MM/YYYY... / mọi chuỗi ngày trình duyệt parse được, trả về
 * HISTORY_DATE_FORMAT. Không nhận diện được thì trả nguyên giá trị gốc thay vì
 * hiện "Invalid Date" hay một ngày sai.
 */
export function formatHistoryDate(value, fallback = "-") {
  if (value === null || value === undefined || value === "") return fallback;
  let parsed;
  if (dayjs.isDayjs(value)) {
    parsed = value;
  } else if (typeof value === "number") {
    parsed = dayjs(toMs(value));
  } else if (typeof value === "string" && /^\d{10,13}$/.test(value.trim())) {
    parsed = dayjs(toMs(Number(value.trim())));
  } else if (typeof value === "string" && DAY_FIRST_RE.test(value.trim())) {
    parsed = dayjs(value.trim(), DAY_FIRST_FORMATS, true);
  } else {
    parsed = dayjs(value);
  }
  return parsed.isValid() ? parsed.format(HISTORY_DATE_FORMAT) : String(value);
}
